<template>
    <div>
        <div class="columns" v-if="isAffiliate">
            <div class="column has-text-centered">
                <h3 class="total-title title">Total: {{ hasUsers }}</h3>
            </div>
        </div>
        <app-loader :loading="getLoaderStatus" :color="options.color" :size="options.size"></app-loader>
        <div class="table-container">
        <table class="table is-fullwidth is-narrow" v-if="!getLoaderStatus">
            <thead>
                <tr>
                    <th class="is-hidden-touch">#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th class="is-hidden-touch">Created</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <table-row v-for="user in users" :user="user" :key="user.id"></table-row>
            </tbody>
        </table>
        </div>
        <div class="columns" v-if="hasUsers">
            <div class="column has-text-centered">
                <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li><a class="pagination-link" v-if="getCurrentPage > 2" @click="changePage(getFirstPage)">{{ getFirstPage }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span></li>
                        <li><a class="pagination-link" v-if="getCurrentPage > 1" @click="changePage(getCurrentPage - 1)">{{ getCurrentPage - 1 }}</a></li>
                        <li><a class="pagination-link is-current" @click="changePage(getCurrentPage)">{{ getCurrentPage }}</a></li>
                        <li><a class="pagination-link" v-if="getCurrentPage < getLastPage"  @click="changePage(getCurrentPage + 1)">{{ getCurrentPage + 1 }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage + 1 < getLastPage">&hellip;</span></li>
                        <li><a class="pagination-link" @click="changePage(getLastPage)" v-if="getCurrentPage + 1 < getLastPage">{{ getLastPage }}</a></li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="columns" v-if="false">
            <div class="column has-text-centered" v-if="!isLastPage">
                <button class="button is-large"
                        @click.prevent="loadMore()">
                    <span>Load More</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import appLoader from 'vue-spinner/src/ClipLoader'
    import UsersTableRow from './UsersTableRow'
    export default {
        components: {
            tableRow: UsersTableRow,
            appLoader: appLoader
        },
        data() {
            return {
                options: this.$store.getters.getOptions
            }
        },
        computed: {
            users() {
                return this.$store.getters.getUsers
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            isLastPage() {
                return this.$store.getters.isLastUsersPage
            },
            isAffiliate() {
                if (this.$store.getters.getUserRole === 'Affiliate') {
                    return true
                }
            },
            hasUsers(){
                return this.$store.getters.getTotalUsers
            },
            getCurrentPage() {
                return this.$store.getters.getCurrentUsersPage
            },
            getFirstPage() {
                return this.$store.getters.getFirstUsersPage
            },
            getLastPage() {
                return this.$store.getters.getLastUsersPage
            }
        },
        methods: {
            loadMore() {
                this.$store.dispatch('loadMoreUsers')
            },
            changePage(page) {
                this.$router.push({path: '/users', query: {page: page}})
            },
            isMobile() {
                return (window.innerWidth <= 760)
            }
        },
        mounted() {
            if(this.$route.query.page !== undefined){
                this.$store.dispatch('loadMoreUsersPagination', this.$route.query.page)
            }else{
                this.$store.dispatch('fetchUsers')
            }
        },
        watch: {
            '$route'(to, from) {
                this.$store.dispatch('loadMoreUsersPagination', to.query.page)
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/UsersTable.vue